export function slotValidate(slot){
    var result = true;

    result = validateId(slot.id);
    result = validateName(slot.name);
    result = validateToteId(slot.tote_id);
    result = validateStationId(slot.station_id);
    result = validateTote(slot.tote);
    result = validateStation(slot.station);
    result = validatePosition(slot.position);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateToteId(tote_id){
    if(Number.isInteger(tote_id) || tote_id == null) return true;
    else return false;
}

function validateStationId(station_id){
    if(Number.isInteger(station_id) || station_id == null) return true;
    else return false;
}

function validateTote(tote){
    if(tote == null) return true;
    else {
        return typeof tote === 'object' && 
        typeof tote.id === "number" &&
        typeof tote.name === "string" &&
        typeof tote.slot_id === "number" &&
        typeof tote.shipment_id === "number" &&
        typeof tote.shipment_type === "string" &&
        typeof tote.warehouse_id === "number"
    }
}

function validateStation(station){
    return typeof station === 'object' && 
    typeof station.id === "number" &&
    typeof station.name === "string" &&
    typeof station.user_id === "number" &&
    typeof station.warehouse_id === "number"
}

function validatePosition(position) {
    if(Number.isInteger(position)) return true;
    else return false;
}